export const quebec = {
  $01: '#2B5D78',
} as const;
